/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { employees_EmployeeAllergyRequest } from './employees_EmployeeAllergyRequest';
import type { employees_EmployeeEmergencyContactRequest } from './employees_EmployeeEmergencyContactRequest';
import type { employees_LanguageWithLevel } from './employees_LanguageWithLevel';
export type employees_UpdateEmployeeRequest = {
    addressId?: string;
    allGroups?: boolean;
    /**
     * Allergies and EmergencyContacts are FULL-LIST replacements: absent (null)
     * leaves the stored list unchanged, [] clears it. Entries with an id update
     * that row, entries without one are created, stored rows missing from the
     * list are deleted.
     */
    allergies?: Array<employees_EmployeeAllergyRequest> | null;
    avatarUrl?: string;
    birthdate?: string;
    clerkUserId?: string;
    /**
     * DirectHeadID is TRI-STATE (issue #1217): absent or null leaves the value
     * unchanged, "" clears it, a non-empty value sets it. This deliberately
     * differs from fields where an absent value means "clear" — that would
     * silently wipe the head on any partial update. x-nullable is required:
     * without it the generated OpenAPI/TypeScript clients type the field as
     * plain string and a strict client rejects the valid null "unchanged" case.
     */
    directHeadId?: string | null;
    email?: string;
    /**
     * Business contact details (migration 179): absent leaves the value
     * unchanged, "" clears it, a value sets it. `|len=0` lets "" past the
     * email rule: omitempty only skips a nil pointer, not a pointer to "".
     */
    emailBusiness?: string;
    emergencyContacts?: Array<employees_EmployeeEmergencyContactRequest> | null;
    external?: boolean;
    firstname?: string;
    gender?: string;
    groupIds?: Array<string>;
    labels?: Array<string>;
    languages?: Array<employees_LanguageWithLevel>;
    lastname?: string;
    nationalities?: Array<string>;
    phone?: string;
    phoneBusiness?: string;
    phoneBusinessCountryCode?: string;
    phoneCountryCode?: string;
    status?: employees_UpdateEmployeeRequest.status;
};
export namespace employees_UpdateEmployeeRequest {
    export enum status {
        ACTIVE = 'ACTIVE',
        INACTIVE = 'INACTIVE',
        UPCOMING = 'UPCOMING',
    }
}

